import { saveNoCC_Complaint } from "../../shared/chatbotNew/ChatServices";
import { toast } from "react-toastify";
import routes from "../../../constants/Routes";
import useSweetAlert from "../../shared/Popups/sweetAlertComponent/useSweetAlert";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentGroupId, setCurrentSubGroupIndex } from "../../../features/editAssessment/editAssessmentSlice";
import CONSTANT from "../../../constants/Constant";
import { useHistory } from "react-router-dom";
import useEditAssessment from "./useEditAssessment";
import examService from "../../../services/ExamService";
import GLOBAL from "../../../global";

const useCCInEditAssessment = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { showSweetAlert, hideSweetAlert, setNoLoading } = useSweetAlert();
    const { clearEditAssessment } = useEditAssessment();

    const editAssessmentGroup = useSelector(state => state.editAssessment);
    const baseData = editAssessmentGroup?.baseData || {};
    const testId = baseData?.testId || "";

    const handleNoCC = async (isProcessAfterSaveMovement = false, closeEditAssessmentPage = true) => {
        setNoLoading(true);
        const response = await saveNoCC_Complaint(testId);
        const { data, error } = response;

        if (error) {
            console.error(error);
            toast.error("Internal Server Error. Please try again")
            return;
        }

        const assessment = {
            TestId: testId,
            Tenant: GLOBAL.TENANT,
            Answers: []
        };

        const ChiefComplaintsQuestionStatus = data?.ChiefComplaintsQuestionStatus;
        if (ChiefComplaintsQuestionStatus) {
            assessment.Answers = [
                {
                    GroupId: CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key,
                    AnswerId: ChiefComplaintsQuestionStatus.AnswerId,
                    AnswerTitle: ChiefComplaintsQuestionStatus.AnswerValue || "No Chief Complaints",
                    QuestionId: ChiefComplaintsQuestionStatus.QuestionId
                }
            ];
        }

        await examService.saveAssessments(assessment);

        if (closeEditAssessmentPage) {
            clearEditAssessment();
            history.push(`${routes.myAssessments}/${false}`);
            hideSweetAlert();
        }
    }

    const handleDirectUserToCCSection = () => {
        dispatch(setCurrentGroupId(CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key));
        dispatch(setCurrentSubGroupIndex(0));
        showSweetAlert({
            title: 'Attention',
            message: 'It is required to fill in chief complaint section.',
            type: CONSTANT.ALERT_TYPE.INFO,
            onConfirm: () => {
                hideSweetAlert();
            },
            showCancelBtn: false,
            showConfirmBtn: false,
            showOkBtn: true,
            confirmBtnText: 'OK',
        });
    }

    return {
        handleDirectUserToCCSection,
        handleNoCC
    }
}

export default useCCInEditAssessment;
